import { Company, useCompanies } from 'src/secret-menu/hooks/useCompanies';
import PageLoader from 'src/UI/loader/PageLoader';
import { Flex, Select } from '@mantine/core';
import { useSelectedCompanyStore } from 'src/secret-menu/stores/useSelectedCompanyStore';

export default function CompanyWrapper({
  contentComponent,
}: {
  contentComponent: React.ElementType<{ company: Company }>;
}) {
  const { companies, isLoading: isLoadingCompanies } = useCompanies();
  return isLoadingCompanies || !companies || companies.length === 0 ? (
    <PageLoader />
  ) : (
    <CompanyWrapperWithLoadedCompanies companies={companies} contentComponent={contentComponent} />
  );
}

function CompanyWrapperWithLoadedCompanies({
  companies,
  contentComponent: ContentComponent,
}: {
  companies: Company[];
  contentComponent: React.ElementType<{ company: Company }>;
}) {
  const { selectedCompanyId, setSelectedCompanyId } = useSelectedCompanyStore();
  const sortedCompanies = [...companies].sort((a, b) => a.name.localeCompare(b.name));

  const selectedCompany =
    sortedCompanies.find(c => c.id === selectedCompanyId) || sortedCompanies[0];

  const handleCompanyChange = (value: string | null) => {
    if (value) {
      setSelectedCompanyId(value);
    }
  };

  return (
    <Flex direction="column" gap="xxl">
      <Flex flex={1} justify={'flex-end'}>
        <Select
          label={'Company'}
          data={sortedCompanies.map(company => ({ label: company.name, value: company.id }))}
          value={selectedCompany.id}
          onChange={handleCompanyChange}
          searchable
          w={500}
        />
      </Flex>
      <ContentComponent key={selectedCompany.id} company={selectedCompany} />
    </Flex>
  );
}
